<template>
  <div>
    
    <Menu />

    <section v-if="!loading">

    <div style="border-top-left-radius: 10px; border-top-right-radius:10px; z-index: 999; position: fixed; bottom: 0; left: 50%; transform: translateX(-50%); padding: 10px; background-color: #efefef;" class="text-center">
      <div class="container">
        <div class="d-flex justify-content-center">
          <div class="d-flex align-items-center me-4">
            <i class="bi bi-whatsapp display-5 text-danger me-2"></i>
            <a v-if="this.agent.first_name != null" target="_blank" class="h5 text-decoration-none text-danger" :href="whatsappLink">
              <strong>{{ agent.first_name }}</strong>
            </a>
          </div>
          <div class="d-flex align-items-center">
            <i class="bi bi-whatsapp display-5 text-danger me-2"></i>
            <a v-if="this.agent_2.first_name != null" target="_blank" class="h5 text-decoration-none text-danger" :href="whatsappLink_2">
              <strong>{{ agent_2.first_name }}</strong>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div id="banner" class="mt-5" v-if="!loading">
      <div class="container-fluid g-0">
        <div class="row justify-content-center g-0">
          <div class="col-12">
            <div class="porfolio-banner">
              <img :src="propertyImage" style="width: 100%;" />
              <div class="property-title-panel">
                <div v-if="ogListing[0].sale_status" class="property-status-strip">{{ ogListing[0].sale_status }}</div>
                <h1 class="text-md-start text-center p-4" style="text-transform: uppercase;"><strong>{{ this.ogListing[0].property_type }}</strong>&nbsp; {{ ogListing[0].loc_suburb }}, {{ ogListing[0].loc_region }}<br/> {{ formattedPrice }}</h1>
              </div>
            </div>
          </div>
        </div>
      </div>  
    </div>

    <div class="wrapper">
      <div class="container">
        <div class="row justify-content-center pb-5 mb-5 pt-5">
          <div class="col-md-2 col-sm-6" v-if="ogListing[0].land_size !== 0">
            <div class="prop-details"><span>Land Size</span>{{ ogListing[0].land_size }}<span>{{ ogListing[0].measurement_type }}</span></div>
          </div>
          <div class="col-md-2 col-sm-6" v-if="ogListing[0].building_size !== 0">
            <div class="prop-details"><span>Building Size</span>{{ ogListing[0].building_size }}<span>{{ ogListing[0].building_measurement_type }}</span></div>
          </div>
          <div class="col-md-2 col-sm-6" v-if="ogListing[0].bedrooms !== 0">
            <div class="prop-details"><span>Bedrooms</span>{{ ogListing[0].bedrooms }}</div>
          </div>
          <div class="col-md-2 col-sm-6" v-if="ogListing[0].bathrooms !== 0">
            <div class="prop-details"><span>Bathrooms</span>{{ ogListing[0].bathrooms }}</div>
          </div>
          <div class="col-md-2 col-sm-6" v-if="ogListing[0].garages !== 0">
            <div class="prop-details"><span>Garages</span>{{ ogListing[0].garages }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid bg-light">

      <div class="row">
        <div class="col-12 text-center">
          <h2 class="pt-5"><strong>CONTACT DETAILS</strong></h2>
        </div>
      </div>
      
      <div class="row justify-content-center pt-5 pb-5">
        
        <div class="col-md-4 text-center" v-if="this.agent.agent_photo">
          <div class="container">
            <div class="row pt-4">
              <div class="col-md-5">
                <img :src="this.agent.agent_photo" style="border-radius: 30px;" class="img img-fluid" />
              </div>
              <div class="col-md-7 text-center">
                <h3 class="switch-blue mb-3 mt-4 text-center"><strong>{{ agent.first_name }} {{ agent.last_name }}</strong></h3>
                <div v-if="!contactRequested">
                  <center><button class="btn btn-primary filter-btn" v-on:click="contactRequested = true">Details</button></center>
                </div>
                <div v-if="contactRequested">
                  <p style="line-height: 26px;"><a style="text-decoration: none;" class="switch-blue" :href="'tel:' + agent.cell_number"><i class="bi bi-telephone-fill"></i> {{ agent.cell_number }}</a><br/>
                  <a style="text-decoration: none;" class="switch-blue" :href="'mailto:' + agent.email_address"><i class="bi bi-envelope-fill"></i> {{ agent.email_address }}</a><br/>
                  <a style="text-decoration: none;" class="switch-blue" :href="whatsappLink" target="_blank"><i class="bi bi-whatsapp"></i> Whatsapp</a></p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 text-center" v-if="this.agent_2.agent_photo">
          <div class="container">
            <div class="row pt-4">
              <div class="col-md-5">
                <img :src="this.agent_2.agent_photo" style="border-radius: 30px;" class="img img-fluid" />
              </div>
              <div class="col-md-7 text-center">
                <h3 class="switch-blue mb-3 mt-4 text-center"><strong>{{ agent_2.first_name }} {{ agent_2.last_name }}</strong></h3>
                <div v-if="!contactRequested_2">
                  <center><button class="btn btn-primary filter-btn" v-on:click="contactRequested_2 = true">Details</button></center>
                </div>
                <div v-if="contactRequested_2">
                  <p style="line-height: 26px;"><a style="text-decoration: none;" class="switch-blue" :href="'tel:' + agent_2.cell_number"><i class="bi bi-telephone-fill"></i> {{ agent_2.cell_number }}</a><br/>
                  <a style="text-decoration: none;" class="switch-blue" :href="'mailto:' + agent_2.email_address"><i class="bi bi-envelope-fill"></i> {{ agent_2.email_address }}</a><br/>
                  <a style="text-decoration: none;" class="switch-blue" :href="whatsappLink_2" target="_blank"><i class="bi bi-whatsapp"></i> Whatsapp</a></p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 text-center" v-if="this.agent_3.agent_photo">
          <div class="container">
            <div class="row pt-4">
              <div class="col-md-5">
                <img :src="this.agent_3.agent_photo" style="border-radius: 30px;" class="img img-fluid" />
              </div>
              <div class="col-md-7 text-center">
                <h3 class="switch-blue mb-3 mt-4 text-center"><strong>{{ agent_3.first_name }} {{ agent_3.last_name }}</strong></h3>
                <div v-if="!contactRequested_3">
                  <center><button class="btn btn-primary filter-btn" v-on:click="contactRequested_3 = true">Details</button></center>
                </div>
                <div v-if="contactRequested_3">
                  <p style="line-height: 26px;"><a style="text-decoration: none;" class="switch-blue" :href="'tel:' + agent_3.cell_number"><i class="bi bi-telephone-fill"></i> {{ agent_3.cell_number }}</a><br/>
                  <a style="text-decoration: none;" class="switch-blue" :href="'mailto:' + agent_3.email_address"><i class="bi bi-envelope-fill"></i> {{ agent_3.email_address }}</a><br/>
                  <a style="text-decoration: none;" class="switch-blue" :href="whatsappLink_3" target="_blank"><i class="bi bi-whatsapp"></i> Whatsapp</a></p>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-md-12 py-5 px-3">
          <center><h2><strong>Description</strong></h2></center>
          <p class="pt-5" v-html="
            (ogListing[0].description || '')
            .replace(/ΓÇó/g, '•')   /* bullet points */
            .replace(/ΓÇô/g, '–')   /* en dash */
            .replace(/â€™/g, '’')   /* right single quote */
            .replace(/â€œ/g, '“')   /* left double quote */
            .replace(/â€/g, '”')   /* right double quote */
            .replace(/â€/g, '…')    /* ellipsis */
            .replace(/┬▒/g, '±')    /* plus-minus */
            .replace(/ΓÇÖ/g, '\'')
          ">
          </p>
        </div>
      </div>
    </div>

    <div class="wrapper">
      <div class="container-fluid">
        <div class="row mt-5">
          <div class="col-12 align-self-center my-4">
            <iframe
              v-if="youtubeEmbedUrl"
              class="property-video"
              :src="youtubeEmbedUrl"
              title="Property video"
              frameborder="0"
              loading="lazy"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen
            ></iframe>

            <div class="position-relative text-center">
              <h2><strong>Gallery</strong></h2>

              <div class="container-fluid">
                <div class="row">
                  <div class="col-md-6" v-for="(item, index) in this.ogListing[0].listing_images">
                      <img :src="item" class="img-fluid py-2" />
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    </section>

    <Footer />
  
  </div>
</template>

<script>
import Menu from '@/components/Menu.vue';
import Footer from '@/components/Footer.vue';
import ContactForm from '@/components/ContactForm.vue';
import { fetchPublicAgent, fetchPublicPropertyByWebRef, normaliseYouTubeVideoId } from '@/services/winelandsApi';

export default {
  components: {
    Menu, Footer, ContactForm
  },
  data() {
    return {
      listing: { 
        data: {
          listing: [
            { on_show: false }
          ]
        }
      },
      ogListing: [
        {
          listing_images: []
        }
      ],
      agent: { },
      agent_2: { },
      agent_3: { },
      loading: true,
      template: 1,
      activeImageIndex: -1,
      isImageExpanded: false,
      isImageClicked: false,
      originalListings: null,
      listings: null,
      contactRequested: false,
      contactRequested_2: false,
      contactRequested_3: false,
      whatsappLink: '',
      whatsappLink_2: '',
      whatsappLink_3: '',
    };
  },
  mounted() {
    this.fetchListing();
  },
  computed: {
    propertyImage() {
      const listing = this.ogListing[0] || {}
      return listing.featured_image || (listing.listing_images && listing.listing_images[0]) || ''
    },
    youtubeEmbedUrl() {
      const listing = this.ogListing[0] || {}
      const videoId = normaliseYouTubeVideoId(listing.video_id)
      return videoId ? 'https://www.youtube.com/embed/' + encodeURIComponent(videoId) + '?rel=0&modestbranding=1' : ''
    },
    formattedPrice() {
      const price = parseInt(this.ogListing[0].price);
      if (this.ogListing[0].poa === true || this.ogListing[0].poa === "true") {
        return "POA"
      } else {
        return "R " + price.toLocaleString();
      }
    },
    formattedDescription() {
      const rawDescription = this.listing.ai_long_description || '';
      const sentences = rawDescription.split('. ');
      const paragraphs = [];
      for (let i = 0; i < sentences.length; i += 3) {
        const paragraph = sentences.slice(i, i + 3).join('. ');
        if (!paragraph.endsWith('.')) {
          paragraphs.push(paragraph + '.');
        } else {
          paragraphs.push(paragraph);
        }
      }
      return paragraphs;
    },
    currentUrl() {
      return encodeURIComponent(window.location.href)
    },
    facebookShareLink() {
      return `https://www.facebook.com/sharer/sharer.php?u=${this.currentUrl}`
    },
    linkedinShareLink() {
      return `https://www.linkedin.com/sharing/share-offsite/?url=${this.currentUrl}`
    },
    pinterestShareLink() {
      return `https://www.pinterest.com/pin/create/button/?url=${this.currentUrl}`;
    },
    twitterShareLink() {
      const text = encodeURIComponent("Luxury property presented by Chas Everitt Luxury Portfolio");
      return `https://twitter.com/intent/tweet?url=${this.currentUrl}&text=${text}`;
    },
  },
  methods: {
    printToPDF() {
      window.print();
    },
    fetchListing: async function () {
      this.loading = true
      try {
        const detail = await fetchPublicPropertyByWebRef(this.$route.params.webRef)
        this.ogListing = [detail.listing]
        this.listing = detail.payload

        const agents = await Promise.all([
          fetchPublicAgent(detail.listing.agent),
          fetchPublicAgent(detail.listing.agent_2),
          fetchPublicAgent(detail.listing.agent_3)
        ])
        this.agent = agents[0]
        this.agent_2 = agents[1]
        this.agent_3 = agents[2]
        this.whatsappLink = this.makeWhatsappLink(this.agent.cell_number)
        this.whatsappLink_2 = this.makeWhatsappLink(this.agent_2.cell_number)
        this.whatsappLink_3 = this.makeWhatsappLink(this.agent_3.cell_number)
      } catch (error) {
        console.log(error)
      }

      this.loading = false
    },
    makeWhatsappLink(number) {
      if (!number) return ''
      const cleanedNumber = String(number).replace(/\D/g, '')
      const formattedNumber = cleanedNumber.startsWith('27') ? cleanedNumber : '27' + cleanedNumber.replace(/^0/, '')
      return `https://wa.me/${formattedNumber}?text=Hello! I am interested in the property I found on your Portfolio website: ${window.location.href}`
    },
    expandImage(index) {
      this.activeImageIndex = index
      this.isImageExpanded = true
      this.isImageClicked = true
    }
  }
};
</script>

<style scoped>
.fixed-tags {
  position: fixed;
  top: 50%;
  right: 0;
  z-index: 1000;
}
.expanded {
  transform: scale(1.2);
  z-index: 1;
}
.social-links{
  position: unset;
  display: inline;
  float: right;
  margin-right: 20px;
}
.force-height {
  height: 300px;
  object-fit: cover;
}
.porfolio-banner {
  position: relative;
}
.property-title-panel {
  position: absolute;
  z-index: 3;
  top: 50%;
  left: 0;
  width: 50%;
  transform: translateY(-50%);
}
.property-title-panel h1 {
  position: static !important;
  width: 100% !important;
  margin: 0 !important;
  transform: none !important;
  background: rgba(255, 255, 255, .82);
}
.property-status-strip {
  width: 100%;
  padding: 12px 24px;
  background: #dc3545;
  color: #fff;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: .08em;
  text-align: left;
  text-transform: uppercase;
}
.property-video {
  display: block;
  width: 100%;
  aspect-ratio: 16 / 9;
}
.carousel-control-next-icon {
  background-color: red;
  border-radius: 25px;
  font-size: 10px;
}
.carousel-control-prev-icon {
  background-color: rgba(0, 0, 0, 1);
  border-radius: 25px;
  font-size: 10px;
}
@media (max-width: 576px) {
  .property-title-panel {
    top: auto;
    bottom: 0;
    width: 100%;
    transform: none;
  }
  .property-status-strip {
    padding: 9px 16px;
    font-size: 11px;
  }
}
</style>
